import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({
  name: 'tiresiaToDate'
})
export class TiresiaToDatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    let taim;
    value.length > 5
      ? (taim = value.substring(0, 4) + '/' + value.substring(4, 6))
      : (taim = value.substring(0, 4) + '/' + value.substring(4, 5));

    taim = new Date(taim);
    const timeformat = formatDate(taim, 'MMMM/yyyy', 'es');

    return timeformat;
  }
}
